// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"241":"824bf26a","740":"c4abccd9"}[chunkId] + ".chunk.js";
};